module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-up-1.ec4a386d.svg";